import { paymentRequest, subscriptionRegister } from "../../api/payment";
import DonateReceiptAgreeModal from "./donate_receipt_agree_modal";
import DonateStep1Modal from "./donate_step1_modal";
import ProductAuthModal from "./product_auth_modal";
import ProductDonateModal from "./product_donate_modal";

const DonationModalContainer = ({
  isProductModalOpen,
  isDonateReceiptAgreeModalOpen,
  isDonateStep1ModalOpen,
  isDonateStep2ModalOpen,
  agreeChecked,
  productId,
  phoneNumber,
  paymentSelect,

  setIsProductModalOpen,
  setIsDonateReceiptAgreeModalOpen,
  setIsDonateStep1ModalOpen,
  setIsDonateStep2ModalOpen,
  setPhoneNumber,
  setPaymentSelect,
  setAgreeChecked,

  kdBusiness,

  paymentType = "card", // ProductPage에서는 "card", DonationPage에서는 다른 값
}) => {
  const handleProductAuthSuccess = async (phoneNumber) => {
    if (productId !== "0") {
      // 일반 상품 결제
      const res = await paymentRequest(
        productId !== "0",
        paymentType,
        productId,
        "",
        "",
        "",
        "",
        agreeChecked
      );
      window.open(res.payment_url);
      setIsProductModalOpen(false);
    } else {
      // 기부
      setIsProductModalOpen(false);
      setPhoneNumber(phoneNumber);
      setIsDonateReceiptAgreeModalOpen(true);
    }
  };

  const handleDonateReceiptAgreeSuccess = async (value) => {
    setIsDonateReceiptAgreeModalOpen(false);
    setIsDonateStep1ModalOpen(true);
    setAgreeChecked(value);
  };

  const handleDonateStep1Success = async (value) => {
    setIsDonateStep1ModalOpen(false);
    setIsDonateStep2ModalOpen(true);
    setPaymentSelect(value);
  };

  const handleProductDonateSuccess = async (
    name,
    amount,
    paymentType,
    subscriptionData
  ) => {
    let res;

    if (paymentSelect === "single") {
      // 일회성 기부
      res = await paymentRequest(
        productId !== "0",
        paymentType || "",
        productId,
        kdBusiness || "",
        name,
        "정기후원",
        amount,
        agreeChecked
      );
      window.open(res.payment_url);
    } else {
      // 정기 기부
      res = await subscriptionRegister(
        0,
        amount,
        subscriptionData["payment_day"],
        subscriptionData["cardNumb"],
        subscriptionData["expiryDate"],
        subscriptionData["password2"],
        subscriptionData["userInfo"],
        subscriptionData["buyer_name"],
        subscriptionData["payment_content"],
        kdBusiness || "",
        agreeChecked
      );

      if (res["success"] === true) {
        alert(res["message"]);
      }
    }

    setIsDonateStep2ModalOpen(false);
  };

  const handleDonateStep1Back = () => {
    setIsDonateStep1ModalOpen(false);
    setIsDonateReceiptAgreeModalOpen(true);
  };

  const handleProductDonateBack = () => {
    setIsDonateStep2ModalOpen(false);
    setIsDonateStep1ModalOpen(true);
  };

  return (
    <>
      <ProductAuthModal
        isOpen={isProductModalOpen}
        onClose={() => setIsProductModalOpen(false)}
        onSuccess={handleProductAuthSuccess}
      />

      <DonateReceiptAgreeModal
        isOpen={isDonateReceiptAgreeModalOpen}
        onClose={() => setIsDonateReceiptAgreeModalOpen(false)}
        onSuccess={handleDonateReceiptAgreeSuccess}
      />

      <DonateStep1Modal
        isOpen={isDonateStep1ModalOpen}
        onBack={handleDonateStep1Back}
        onClose={() => setIsDonateStep1ModalOpen(false)}
        onSuccess={handleDonateStep1Success}
      />

      <ProductDonateModal
        isOpen={isDonateStep2ModalOpen}
        onBack={handleProductDonateBack}
        onClose={() => setIsDonateStep2ModalOpen(false)}
        phoneNumber={phoneNumber}
        paymentSelect={paymentSelect}
        onSuccess={handleProductDonateSuccess}
      />
    </>
  );
};

export default DonationModalContainer;
